import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-primary fw-normal border border-lightgray border-top-0 border-start-0 border-end-0 pb-3 my-5" }, " Text: ", -1)
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-secondary mb-0" }, "Insert Text:", -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "25",
  selected: ""
}, "Font Size", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("canvas", {
  class: "d-none",
  id: "text-canvas"
}, null, -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "text-secondary mt-5"
}
const _hoisted_11 = { class: "border border-lightgray border-bottom-0 border-start-0 border-end-0 mt-5 pt-4 row mx-auto" }
const _hoisted_12 = { class: "col-12 col-sm d-flex justify-content-end px-0" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}

import router from "@/router";
import { storeToRefs } from "pinia";
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";
import { pointObject } from "@/interfaces";
import { exportImage } from "@/composable/useTextToImage";
import { onMounted, reactive, ref } from "vue";
import { handleImages } from "@/composable/useHandleImages";
import BaseSelect from "@/components/base-components/BaseSelect.vue";
import { useProjectStimuliStore } from "@/store/ProjectStimuliStore";
import RangeSlider from "@/components/base-components/RangeSlider.vue";
import BaseTextarea from "@/components/base-components/BaseTextArea.vue";
import AreaofInterest from "@/components/base-components/AreaOfInterest.vue";
import BaseInputUnderline from "@/components/base-components/BaseInputUnderline.vue";


const __default__ = {
  name: "TextStimuli",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stimuliUUID: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const projectStimuliStore = useProjectStimuliStore();
const { project } = storeToRefs(projectStimuliStore);
const { addStimuli, getStimul, updateStimuli } = projectStimuliStore;
const img = ref("");
const file = ref(null);
const maxLength = ref(800);
const imageSrc = ref();
const route = useRoute();
const loading = ref(false);

onMounted(async () => {
  form.id = props.stimuliUUID;
  if (route.name === "CreateStimuli") return;

  const stimul = getStimul(route.params.stimulId);
  if (stimul.type !== "text") return;

  form.id = stimul.id;
  form.textarea = stimul.textarea;
  form.order = stimul.order;
  form.duration = stimul.duration;
  form.areasOfInterest = stimul.areasOfInterest;
  form.name = stimul.name;
  imageSrc.value = stimul.imgSrc;
  form.fontSize = stimul.fontSize;
  form.question = stimul.question;
  form.requiredClicks = stimul.requiredClicks;
  callExport();
});

const form = reactive({
  id: "",
  order: 0,
  duration: 5,
  type: "text",
  question: "",
  requiredClicks: 0,
  areasOfInterest: "",
  name: "Text Stimuli",
  textarea: "",
  imgSrc: "",
  fontSize: 25,
});

const save = async () => {
  try {
    loading.value = true;
    if (form.textarea === "" && form.imgSrc === "") {
      toast.error("You have to insert some text!");
      return;
    }
    if (route.name === "EditStimuli") {
      if (form.areasOfInterest === "") {
        delete form.areasOfInterest;
      }
      updateStimuli(form);
      toast.success("Text stimuli was updated successfully!");
    } else {
      let current;
      await handleImages(project.value?.id, form.id, [file.value]);
      form.id = props.stimuliUUID;
      project.value?.stimuli === undefined
        ? (current = 0)
        : (current = project.value?.stimuli.length);
      form.order = current + 1;
      if (form.areasOfInterest === "") {
        delete form.areasOfInterest;
      }
      addStimuli(form);
      toast.success("Text stimuli was created successfully!");
    }
  } catch (e) {
    console.log(e);
    toast.error("Creation of text stimuli has failed!");
  } finally {
    loading.value = true;
    await router.push("/projects/create");
  }
};

const changeAreas = (areasOfInterest: Array<pointObject>) => {
  form.areasOfInterest = JSON.stringify(areasOfInterest);
};

const callExport = async () => {
  if (form.fontSize === 30 || form.fontSize === 20 || form.fontSize === 25) {
    maxLength.value = 800;
  } else if (form.fontSize === 40) {
    maxLength.value = 420;
  } else if (form.fontSize === 50) {
    maxLength.value = 425;
  }
  if (form.textarea.length + 1 >= maxLength.value) {
    toast.error(
      "Your text is too big, try to minimize your text or your font!"
    );
    return;
  }
  const canvas = document.getElementById("text-canvas") as HTMLCanvasElement;
  if (canvas !== null) {
    const context = canvas.getContext("2d") as CanvasRenderingContext2D;
    const [newImg, newFile, aLotLines] = await exportImage(
      canvas,
      context,
      form.textarea,
      img.value,
      file.value,
      form.fontSize,
      10
    );
    if (!aLotLines) return;
    img.value = newImg;
    file.value = newFile;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(save, ["prevent"]),
    role: "form",
    class: "pb-5 ui form"
  }, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseSelect, {
          value: form.fontSize,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.fontSize) = $event)),
          name: "text-stimuli-font-size",
          onChange: callExport
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([20, 30, 40, 50], (value) => {
              return _createElementVNode("option", {
                key: value,
                value: value
              }, _toDisplayString(value), 9, _hoisted_7)
            }), 64))
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createVNode(BaseTextarea, {
      value: form.textarea,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.textarea) = $event)),
      onKeyup: callExport,
      name: "text-stimuli-text",
      id: "text-stimuli-text",
      height: "h-200",
      placeholder: "Write text here",
      maxlength: maxLength.value
    }, null, 8, ["value", "maxlength"]),
    _hoisted_8,
    (img.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          id: "exportedImage",
          src: img.value,
          alt: "img",
          class: "border mt-5 w-100 d-none"
        }, null, 8, _hoisted_9))
      : _createCommentVNode("", true),
    (img.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Mark areas of interest:"))
      : _createCommentVNode("", true),
    (img.value)
      ? (_openBlock(), _createBlock(AreaofInterest, {
          key: 2,
          name: "TextStimuli",
          onChangeAreas: changeAreas,
          imgSrc: img.value,
          "drawed-rectangles": form.areasOfInterest
        }, null, 8, ["imgSrc", "drawed-rectangles"]))
      : _createCommentVNode("", true),
    _createVNode(RangeSlider, {
      class: "mt-5",
      value: form.duration,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.duration) = $event)),
      min: "5",
      max: "20",
      unit: "seconds",
      label: "Time Lapse",
      id: "timeFader"
    }, null, 8, ["value"]),
    _createVNode(RangeSlider, {
      value: form.requiredClicks,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.requiredClicks) = $event)),
      min: "0",
      max: "5",
      unit: "clicks",
      label: "Clicks",
      id: "clicksFader"
    }, null, 8, ["value"]),
    (form.requiredClicks >= 1)
      ? (_openBlock(), _createBlock(BaseInputUnderline, {
          key: 3,
          class: "my-5 col-12 col-sm-9 col-md-6",
          value: form.question,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.question) = $event)),
          name: "text-question",
          type: "text",
          id: "text-question",
          "aria-placeholder": "What do you think?",
          placeholder: "What do you think?",
          label: "Write a question",
          required: form.requiredClicks >= 1
        }, null, 8, ["value", "required"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          disabled: loading.value,
          class: "btn btn-primary text-light rounded-pill py-1",
          type: "submit"
        }, [
          _createTextVNode(" Save "),
          _hoisted_14,
          (loading.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_15))
            : _createCommentVNode("", true)
        ], 8, _hoisted_13)
      ])
    ])
  ], 40, _hoisted_1))
}
}

})